import { useContext, Dispatch } from 'react';
import {
  ReportsFiltersContext,
  ReportsFiltersDispatchContext,
  ReportsViewModeContext,
  ReportsViewModeContextData,
} from './index';
import { ReportFilters } from '../../models/reports';

export function useReportsFilters(): ReportFilters | null {
  return useContext(ReportsFiltersContext);
}

export function useReportsFiltersDispatch(): Dispatch<Partial<ReportFilters> | null> {
  return useContext(ReportsFiltersDispatchContext);
}

export function useReportsViewMode(): ReportsViewModeContextData {
  return useContext(ReportsViewModeContext);
}
